import LogCannon from '@ace-clublabs/log-cannon';
import { IGetConfirmationRequest } from '@lib/types';
import axios from 'axios';
import StatusCode from 'status-code-enum';
import { ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { GetConfirmation } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const GetConfirmationApi =
  (endpoint: string): GetConfirmation =>
  async (request: IGetConfirmationRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      LogCannon.blast('GetConfirmationApi scenario', { scenario });

      const url = `${endpoint}?transactionId=${request.transactionId}`;
      LogCannon.blast('GetConfirmationApi start', {
        endpoint: url,
        transactionId: request.transactionId,
      });
      const { data, status } = await axios.get(url, createAxiosConfig(scenario, endpoint));

      LogCannon.blast('GetConfirmationApi success');

      return Promise.resolve({ data, status });
    } catch (error: any) {
      LogCannon.error('GetConfirmationApi error', { error: error?.message });

      const errorResponse = error?.response;
      if (errorResponse) {
        if (errorResponse.status === StatusCode.ClientErrorPaymentRequired) {
          return Promise.reject({
            message: errorResponse.data?.error?.message,
            type: errorResponse.data?.error?.type || ErrorType.PAYMENT_ERROR,
            clubCode: errorResponse.data?.clubCode,
          });
        } else {
          return Promise.reject({
            message: errorResponse.data?.error?.message,
            type: ErrorType.SYSTEM_ERROR,
            clubCode: errorResponse.data?.clubCode,
          });
        }
      } else {
        return Promise.reject({
          message: error,
          type: ErrorType.UNKNOWN,
        });
      }
    }
  };
